{
  "SET_NEW_PASSWORD": {
    "TITLE": "Set new password",
    "PASSWORD": {
      "LABEL": "Heslo",
      "PLACEHOLDER": "Heslo",
      "ERROR": "Heslo je příliš krátké."
    },
    "CONFIRM_PASSWORD": {
      "LABEL": "Confirm password",
      "PLACEHOLDER": "Potvrzení hesla",
      "ERROR": "Hesla se neshodují."
    },
    "API": {
      "SUCCESS_MESSAGE": "Heslo bylo úspěšně změněno.",
      "ERROR_MESSAGE": "Nelze se připojit k Woot serveru, opakujte akci později"
    },
    "CAPTCHA": {
      "ERROR": "Ověření vypršelo. Vyřešte captchu znovu."
    },
    "SUBMIT": "Odeslat"
  }
}
